// Mirrors the CSS `object-position: <x>% <y>%` shorthand; anything else (keywords,
// lengths, single values) falls back to centered.
const OBJECT_POSITION_PATTERN = /^(-?\d+(?:\.\d+)?)%\s+(-?\d+(?:\.\d+)?)%$/;
const CENTERED_OBJECT_POSITION = { x: 50, y: 50 };

export const parseObjectPosition = (objectPosition?: string): { x: number; y: number } => {
  const matches = objectPosition?.trim().match(OBJECT_POSITION_PATTERN);

  if (!matches) {
    return CENTERED_OBJECT_POSITION;
  }

  return { x: Number.parseFloat(matches[1]), y: Number.parseFloat(matches[2]) };
};

// CMS-authored values reach styled-components as raw CSS, where a `}` would close the rule
// and inject into the global stylesheet. Rebuilding the string from the parsed numbers means
// only digits, `.`, `-` and `%` can ever be emitted. Returns undefined when the value is not
// the `<x>% <y>%` shorthand, so callers can skip the declaration entirely.
export const normalizeObjectPosition = (objectPosition?: string): string | undefined => {
  if (!objectPosition?.trim().match(OBJECT_POSITION_PATTERN)) {
    return undefined;
  }

  const { x, y } = parseObjectPosition(objectPosition);

  return `${x}% ${y}%`;
};
